import EditorPanelButton from "./EditorPanelButton";
import {useCallback} from "react";
import useObjectEditStore from "../../../store/useObjectEditStore";
import IconItalic from "../../../public/images/italic.svg";

const ItalicButton = () => {
  const objectEditStore = useObjectEditStore();

  const handleItalicTextClick = useCallback(() => {
    const objectEdit = () => {
      const element = objectEditStore.objectEdit.element;
      const italic = objectEditStore.objectEdit.italic === 'italic' ? 'normal' : 'italic';
      element.style.fontStyle = italic;
      return {
        ...objectEditStore.objectEdit,
        italic: italic,
      };
    }
    objectEditStore.setObjectEdit(objectEdit());
  }, [objectEditStore.objectEdit]);

  return (
    <EditorPanelButton onClick={handleItalicTextClick} icon={IconItalic}/>
  );
};

export default ItalicButton;
